import React, { useEffect, useState } from "react";
import { BarChart } from "@mui/x-charts/BarChart";

import { StyledStack } from "./styles";
import { HubChartTitle } from "../HubChartTitle";
import { Grid } from "./helper";
import { tryAddingGuideLinesToGraph } from "../../../helpers/svgHelper";

export const HubBarChart = ({ field, ...rest }) => {
  const [height, setHeight] = useState(250);

  const keys = field?.series?.map((s) => s?.value);
  const values = field?.series?.map((s) => s?.count);

  // Select the SVG container by its class
  const BarChartContainer = document.getElementById(
    `BarChartElement-root-${field?.name}`
  );

  useEffect(() => {
    if (BarChartContainer) {
      const elementHeight = BarChartContainer.offsetHeight;
      setHeight(elementHeight - 91);

      const allRects = BarChartContainer.querySelectorAll(
        ".MuiBarElement-root"
      );

      if (allRects?.length) {
        allRects.forEach((rect) => {
          rect.setAttribute("rx", "5");
          rect.setAttribute("ry", "5");
        });
      }
    }
  }, [BarChartContainer]);

  useEffect(() => {
    if (height) {
      tryAddingGuideLinesToGraph({ ParentElement: BarChartContainer });
    }
  }, [height, BarChartContainer]);

  return (
    <StyledStack
      key={field.name}
      type={field?.type}
      id={`BarChartElement-root-${field?.name}`}
    >
      <HubChartTitle type={field?.type} name={field?.name} />
      <Grid />
      <BarChart
        height={height}
        series={[{ data: values, type: "bar" }]}
        xAxis={[{ scaleType: "band", data: keys }]}
        {...rest}
      />
    </StyledStack>
  );
};

export default HubBarChart;
